export const errorDotIndicatorStyles = {
  width: 4,
  height: 4,
  borderRadius: '50%',
  background: ({ palette }) => palette.text.error,
  flexShrink: 0,
};
